import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, MapPin } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import axios from 'axios';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_46fcd73e-03d2-4567-a4ea-9e3f8b292ac2/artifacts/qlzjjr45_logo-dkr-consulting.png";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Footer = () => {
    const { t } = useLanguage();
    const [linkedinUrl, setLinkedinUrl] = useState('https://linkedin.com');

    useEffect(() => {
        const fetchPresentation = async () => {
            try {
                const response = await axios.get(`${API}/presentation`);
                if (response.data?.linkedin_url) {
                    setLinkedinUrl(response.data.linkedin_url);
                }
            } catch (error) {
                console.error('Error fetching presentation:', error);
            }
        };
        fetchPresentation();
    }, []);

    return (
        <footer data-testid="main-footer" className="bg-slate-900/50 border-t border-white/10">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
                    {/* Brand */}
                    <div className="lg:col-span-2">
                        <Link to="/" className="flex items-center gap-3 mb-6">
                            <img src={LOGO_URL} alt="DKR CONSULTING" className="h-14 w-auto rounded-full" />
                        </Link>
                        <p className="text-slate-400 max-w-md mb-6">
                            {t(
                                'Ingénieur Informatique & Business Analyst Senior avec plus de 15 ans d\'expérience. Expertise en AMOA, développement et gestion de projets SI.',
                                'Senior IT Engineer & Business Analyst with over 15 years of experience. Expertise in Business Analysis, development and IT project management.'
                            )}
                        </p>
                        <div className="flex items-center gap-4">
                            <a 
                                href="mailto:contact@dkr-consulting.com" 
                                className="p-3 rounded-full bg-white/5 hover:bg-blue-500/20 text-slate-400 hover:text-blue-400 transition-colors"
                                data-testid="footer-email"
                            >
                                <Mail size={20} />
                            </a>
                            <a 
                                href={linkedinUrl}
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="p-3 rounded-full bg-white/5 hover:bg-blue-500/20 text-slate-400 hover:text-blue-400 transition-colors"
                                data-testid="footer-linkedin"
                            >
                                <Linkedin size={20} />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="font-semibold text-white mb-6">{t('Navigation', 'Navigation')}</h4>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/" className="text-slate-400 hover:text-white transition-colors">
                                    {t('Accueil', 'Home')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/formations" className="text-slate-400 hover:text-white transition-colors">
                                    {t('Formations', 'Education')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/experiences" className="text-slate-400 hover:text-white transition-colors">
                                    {t('Expériences', 'Experience')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/services" className="text-slate-400 hover:text-white transition-colors">
                                    Services
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-slate-400 hover:text-white transition-colors">
                                    Contact
                                </Link>
                            </li>
                            <li>
                                <Link to="/togalma/confidentialite" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-togalma-privacy">
                                    {t('Confidentialité TOGALMA', 'TOGALMA Privacy')}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="font-semibold text-white mb-6">Contact</h4>
                        <ul className="space-y-4">
                            <li className="flex items-start gap-3 text-slate-400">
                                <MapPin size={20} className="mt-1 text-blue-400 flex-shrink-0" />
                                <span>{t('France / Sénégal / International', 'France / Senegal / International')}</span>
                            </li>
                            <li className="flex items-center gap-3 text-slate-400">
                                <Mail size={20} className="text-blue-400 flex-shrink-0" />
                                <a href="mailto:contact@dkr-consulting.com" className="hover:text-white transition-colors">
                                    contact@dkr-consulting.com
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom */}
                <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
                    <p className="text-slate-500 text-sm">
                        © {new Date().getFullYear()} DKR CONSULTING. {t('Tous droits réservés.', 'All rights reserved.')}
                    </p>
                    <p className="text-slate-500 text-sm">
                        Djiby NDIAYE - {t('Ingénieur Informatique', 'IT Engineer')}
                    </p>
                </div>
            </div>
        </footer>
    );
};
